import React from 'react'

// Converte um hex (#RRGGBB) em rgba com alpha, para o fundo suave do círculo do ícone.
const softBg = (hex, alpha = 0.15) => {
  if (typeof hex !== 'string' || !/^#([0-9a-f]{6})$/i.test(hex)) return 'transparent'
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const SimpleCard = ({ title, value, color, className, position, children, icon, iconColor }) => {
  const texts =
    position === 'bottom' ? (
      <div>
        <span className="simplecard__value" style={{ color: color }}>
          {value}
        </span>
        <span className="simplecard__title">{title}</span>
      </div>
    ) : (
      <div>
        <span className="simplecard__title">{title}</span>
        <span className="simplecard__value" style={{ color: color }}>
          {value}
        </span>
      </div>
    )

  if (icon) {
    const tone = iconColor ?? color
    return (
      <div className={`simplecard simplecard--with-icon ${className ?? ''}`}>
        <span
          className="simplecard__icon"
          style={{ color: tone, backgroundColor: softBg(tone) }}
          aria-hidden="true"
        >
          {icon}
        </span>
        <div className="simplecard__body">{texts}</div>
        {children}
      </div>
    )
  }

  return (
    <div className={`simplecard ${className ?? ''}`}>
      {texts}
      {children}
    </div>
  )
}

export default { SimpleCard }
